import { render, staticRenderFns } from "./complaint.vue?vue&type=template&id=e1724882&scoped=true"
import script from "./complaint.vue?vue&type=script&lang=js"
export * from "./complaint.vue?vue&type=script&lang=js"
import style0 from "./complaint.vue?vue&type=style&index=0&id=e1724882&prod&scoped=true&lang=less"
import style1 from "./complaint.vue?vue&type=style&index=1&id=e1724882&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1724882",
  null
  
)

export default component.exports